<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import fackClickOutSide from '../static/js/fackClickOutSide.js'
export default {
  name: 'App',
  // mixins: [fackClickOutSide],
  mounted () {
    this.winSizeChange()
    window.onresize = () => {
      this.winSizeChange()
    };
  },
  methods: {
    // 窗口变化
    winSizeChange () {
      let winH = document.body.clientHeight
      let barHeight = winH - 260
      this.$store.commit('SET_TABLEHEIGHT', barHeight)
    },
  },
}
</script>
